import { Progress } from 'antd';
import { useTheme } from 'styled-components';
import { calculateProgress } from '../../utils/dateHelpers';

interface DateProgressProps {
  startDate: string;
  endDate: string;
  className?: string;
  strokeColor?: string | { [key: string]: string };
  size?: { width?: number; height?: number };
}

export const DateProgress = ({
  startDate,
  endDate,
  className,
  strokeColor,
  size = { height: 5 },
}: DateProgressProps) => {
  const progress = calculateProgress(startDate, endDate);
  const theme = useTheme();

  return (
    <Progress
      percent={progress}
      showInfo={false}
      className={className}
      strokeColor={strokeColor ?? theme.progressBarFill}
      size={size}
    />
  );
};
